// # 點數方案相關設定
// 方案資料來自 GET /api/Point（僅回傳上架 Launch 的方案）

// # 點數與台幣的兌換比例（1 點 = NT$1）
export const POINT_TO_NTD = 1;

// # 訂單來源（對應後端 OrderSource）
export const ORDER_SOURCE = {
  ActivityTicket: 1,
  Point: 2,
};

// # 錢包類型（對應後端 WalletType）
export const WALLET_TYPE = {
  Cash: 1,
  Reward: 2,
  Promotion: 3,
};

// # 標籤顏色：後端 tag 為自由文字，未命中時退回藍色
const tagStyleMap = {
  熱門: "popular",
  推薦: "popular",
  加贈最多: "combo",
  超值: "combo",
  好友包: "value",
  限時: "value",
};

export const getTagStyle = (tag) => tagStyleMap[tag] || "popular";

// # 將 API 回傳的方案轉為前台顯示用格式
export const normalizePointPlan = (plan) => {
  const amount = Number(plan.amount || 0);
  const bonusAmount = Number(plan.bonusAmount || 0);
  return {
    id: plan.id,
    name: plan.name || "點數方案",
    tag: plan.tag || null,
    price: Number(plan.price || 0),
    amount,
    bonusAmount,
    totalAmount: Number(plan.totalAmount ?? amount + bonusAmount),
    description: plan.description || "",
    isDefault: Boolean(plan.isDefault),
  };
};

// # 方案在購買摘要中的顯示名稱
export const getPointPlanTitle = (plan) =>
  plan.bonusAmount > 0
    ? `買 ${plan.amount.toLocaleString()} 送 ${plan.bonusAmount.toLocaleString()} 點`
    : `${plan.amount.toLocaleString()} 點`;

// # 方案的條列特色
// 後台的 description 是以換行分隔的條列（含加贈與效期），直接拆行使用；
// 沒填時才由方案數值推導，避免重複顯示「加贈 N 點」。
export const getPointPlanFeatures = (plan) => {
  const lines = String(plan.description || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  if (lines.length > 0) return lines;

  return [
    plan.bonusAmount > 0 ? `加贈 ${plan.bonusAmount.toLocaleString()} 點` : null,
    "點數無使用期限",
  ].filter(Boolean);
};
